import React, { PureComponent } from 'react';
import Card from './card';
import permanentPosMaterialIcon from '../../../../images/permanent-pos-material-icon.png';
import temporaryPosMaterialIcon from '../../../../images/temporary-pos-material-icon.png';
import { Container, TitleContainer, Image, Text, Grid  } from './material.styles';

const Title = ({ icon, value }) => (
  <TitleContainer>
    <Image src={icon} />
    <Text>{value}</Text>
  </TitleContainer>
);

class Material extends PureComponent {
  render() {
    const { data } = this.props;
    if (!data)
      return null;
    const permanentMaterial = data.filter(
      equipment => equipment.getIn(['category', 'type']) === 'PERMANANT MATERIAL'
    );
    const temporaryMaterial = data.filter(
      equipment => equipment.getIn(['category', 'type']) === 'TEMPORARY MATERIAL'
    );
    return (
      <Container>
        <Title icon={permanentPosMaterialIcon} value={'Permanent POS Material'}/>
        <Grid>
          {
            permanentMaterial.map(
              pm => pm.get('owner') && <Card key={pm.get('id')} tmo={pm.get('owner').get('id')} name1={pm.get('category').get('subtype')} name2={pm.getIn(['communication', 'name'], 'Unspecified')} count={pm.get('quantity')} image={pm.get('image')} />
            )
          }
        </Grid>
        <Title icon={temporaryPosMaterialIcon} value={'Temporary POS Material'}/>
        <Grid>
          {
            temporaryMaterial.map(
              tm => tm.get('owner') &&  <Card key={tm.get('id')} tmo={tm.get('owner').get('id')} name1={tm.get('category').get('subtype')} name2={tm.getIn(['communication', 'name'], 'Unspecified')} count={tm.get('quantity')} image={tm.get('image')} />
            )
          }
        </Grid>
      </Container>
    );
  }
}

export default Material;
